import script from "./DeleteChatHistoryDialogue.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteChatHistoryDialogue.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteChatHistoryDialogue.vue?vue&type=style&index=0&id=7bfe373f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bfe373f"]])

export default __exports__